import Joi from "joi"

const EmailFormObject = Joi.object({
    name:Joi.string().min(3).max(15).required(),
    email:Joi.string().email({tlds:{allow: false}}).required()
})

export const Validate = async(formData)=>{
    const status = EmailFormObject.validate(formData)

    if(status.error){
        return status.error.details[0];
    }
    return null;
}

